import bingoToolbar from './index.vue';
export default bingoToolbar;



// WEBPACK FOOTER //
// ./src/components/bingo-toolbar/index.js